module.exports = __webpack_public_path__ + "static/media/solesmes.0373ba13.jpg";